const keys = ['civitas_state', 'civitas_district', 'civitas_district_keys']
const ownerKey = 'civitas_preference_owner'
const guestKey = 'civitas_guest_district_snapshot'

// Existing UI reads these three keys. Switch their scope before mounting a
// different account, while preserving the guest's independent selection.
export function switchPreferenceScope(userId, storage = localStorage) {
  const next = userId || 'guest'
  const knownOwner = storage.getItem(ownerKey)
  const previous = knownOwner || 'guest'
  if (previous === next) {
    storage.setItem(ownerKey, next)
    return
  }
  if (previous === 'guest' && knownOwner === 'guest') {
    storage.setItem(guestKey, JSON.stringify(Object.fromEntries(keys.map(key => [key, storage.getItem(key)]))))
  }
  for (const key of keys) storage.removeItem(key)
  if (next === 'guest') {
    let saved
    try { saved = JSON.parse(storage.getItem(guestKey) || '{}') } catch { saved = {} }
    for (const key of keys) {
      if (typeof saved?.[key] === 'string') storage.setItem(key, saved[key])
    }
  }
  storage.setItem(ownerKey, next)
}
